
import { TranslationKey } from './types';
import { translations } from './translations';
import { getLanguage } from './languageManager';
import { tx, sourceMessages } from './sourceTranslator';

export const t = (key: TranslationKey): string => {
  const currentLanguage = getLanguage();
  
  const source = translations['pt-BR']?.[key];
  if (typeof source === 'string' && sourceMessages[currentLanguage]?.[source] !== undefined) return tx(source);

  // Get translation from current language or fallback to default
  const translation = translations[currentLanguage]?.[key] || translations['pt-BR']?.[key];
  
  // Make sure we're always returning a string
  if (typeof translation === 'string') {
    return translation;
  } else if (translation === undefined || translation === null) {
    // Return the key itself if no translation found
    return String(key);
  } else {
    // If it's an object or array, return stringified key to avoid rendering objects
    console.warn(`Translation for key "${key}" is not a string:`, translation);
    return String(key);
  }
};
